module.exports = __webpack_public_path__ + "img/left3.23ae7d1.png";